// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Symy","left":"StickyBox_left__F18Yt","right":"StickyBox_right__22Atr"};